import React from 'react';
import { motion } from 'framer-motion';
import { CalendarDays, Sun, ThermometerSun } from 'lucide-react';

const Season = () => {
  const months = [
    "Oktober", "November", "December", "Januar", "Februar", "Marts"
  ];

  return (
    <section className="pt-32 pb-24 bg-[var(--brand)] overflow-hidden relative">
      {/* Decorative background sun */}
      <div className="absolute -top-20 -right-20 w-64 h-64 bg-white/10 rounded-full blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 text-white font-medium text-sm mb-6 uppercase tracking-wider">
              <Sun size={16} />
              Forlæng sæsonen
            </div>
            <h2 className="text-3xl md:text-4xl font-medium text-white mb-6 uppercase">
              Rejs når Danmark er koldt – og Spanien er mildt
            </h2>
            <p className="text-white text-lg leading-relaxed mb-8">
              Golf4Life arrangerer især ophold i vinterhalvåret. Det er oplagt for dig, der gerne vil forlænge golfsæsonen og nyde sol, golf og fællesskab, mens mørket sænker sig over Danmark.
            </p>
            
            <div className="flex flex-wrap items-center gap-y-2 mb-10">
              {months.map((month, index) => (
                <div 
                  key={month} 
                  className={`text-white font-medium ${
                    index !== months.length - 1 ? 'border-r border-white/30 pr-4 mr-4' : ''
                  }`}
                >
                  {month}
                </div>
              ))}
            </div>

            <div className="grid grid-cols-2 gap-6">
              <div className="flex items-start gap-3">
                <ThermometerSun className="text-white shrink-0" size={24} />
                <div>
                  <p className="font-medium text-white">Mildt klima</p>
                  <p className="text-sm text-white">Perfekt spillevejr hele vinteren</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <CalendarDays className="text-white shrink-0" size={24} />
                <div>
                  <p className="font-medium text-white">Fleksibel varighed</p>
                  <p className="text-sm text-white">Fra 2 uger til flere måneder</p>
                </div>
              </div>
            </div>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="rounded-3xl overflow-hidden shadow-xl border-8 border-white">
              <img 
                src="https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/dbd1152f-685f-426b-91e5-9cbfaf117142.jpg" 
                alt="Golf i vintersolen" 
                className="w-full h-auto"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Season;
